import React from 'react'

const Createcollection = () => {
    return (
        <>
            <section className="createcollectionmain">

                <div className="headercreatcollection">
                    <h4 className="headerheading">Create Collection</h4>
                    <button className="btncreatecollection">
                        Publish
                    </button>
                </div>
                <div className="innercreatecollection">

                    <div className="bannerssinnner">
                        <h4>Banner Image</h4>
                        <div className="item-upload">
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <input id="upload-edit" type="file" className="d-none" />
                                    <label htmlFor="upload-edit">

                                        <div className="uploadimgprnt">
                                            <img src="/assestsss/gallery-add.svg" className="img-fluid" />
                                            <h4>Drag your image here</h4>
                                            <p>(Size 16:9)</p>
                                        </div>


                                    </label>
                                </li>
                            </ul>
                        </div>

                        <div className="filedinput">
                            <p className='titlecreatecollection'>Title</p>
                            <input type="text" placeholder="URL" />
                        </div>
                        <div className="filedinput">
                            <p className='titlecreatecollection'>Description</p>
                            <textarea
                                className='textarea'
                                id="myTextarea"
                                placeholder="Description"
                                rows={5}
                                cols={40}

                            />
                        </div>


                    </div>
                    <div className="rightsectioncreate">
                        <h4>Add Products</h4>
                        <div className="search-field w-100">
                            <img
                                src="\nav-assets\search-normal.svg"
                                alt="img"
                                className="search-icon"
                            />
                            <input
                                type="text"
                                placeholder="Search"
                                className="parent-input"

                            />
                            <div class="dropdown dropdown-text-parent">
                                <h6
                                    className="dropdown-text"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    By name
                                    <img
                                        src="\assestsss\arrow1.svg"
                                        alt="img"
                                        className="img-fluid ml-1"
                                    />
                                </h6>

                                <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    <div className="input-field">
                                        <span>#</span>
                                        <label className='lablefirstinput'> Products</label>
                                    </div>
                                    <div className="input-field  inputlastfieldss">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="defaultCheck1"

                                        />
                                       <div className="contenttable">
                                            <img src="\dashbord\cntimg.svg" alt="" className="img-fluid" />
                                            <label className='innernamecnt'>Freshmaker Wipes</label>
                                        </div>
                                    </div>
                                    <div className="input-field  inputlastfieldss">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="defaultCheck1"

                                        />
                                         <div className="contenttable">
                                            <img src="\dashbord\cntimg.svg" alt="" className="img-fluid" />
                                            <label  className='innernamecnt'>Freshmaker Wipes</label>
                                        </div>
                                    </div>
                                    <div className="input-field  inputlastfieldss">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="defaultCheck1"

                                        />
                                        <div className="contenttable">
                                            <img src="\dashbord\cntimg.svg" alt="" className="img-fluid" />
                                            <label>Freshmaker Wipes</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="middlecntcreatecnt">
                            <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
                                <path d="M31.76 14.6657L52.8241 21.6865L56.2344 13.928L34.8634 6.67188L31.76 14.6657Z" fill="#C1C1C1" />
                                <path d="M31.76 31.0842L34.8634 38.8426L56.2344 31.821L52.8241 24.0635L31.76 31.0842Z" fill="#C1C1C1" />
                                <path d="M29.239 14.6657L26.1366 6.67188L4.76562 13.928L8.17686 21.6865L29.239 14.6657Z" fill="#C1C1C1" />
                                <path d="M29.239 31.0842L8.17686 24.0635L4.76562 31.821L26.1366 38.8426L29.239 31.0842Z" fill="#C1C1C1" />
                                <path d="M34.3125 40.9847C33.9332 40.9847 33.5767 40.7569 33.427 40.3861L31.4531 35.4499V54.3284L52.4219 46.9693V35L34.6137 40.9361C34.5146 40.9685 34.4116 40.9847 34.3125 40.9847Z" fill="#C1C1C1" />
                                <path d="M10.6396 22.8753L30.4999 29.4957L50.3611 22.8753L31.453 16.5732V24.7816C31.453 25.3077 31.026 25.7347 30.4999 25.7347C29.9738 25.7347 29.5468 25.3077 29.5468 24.7816V16.5732L10.6396 22.8753Z" fill="#C1C1C1" />
                                <path d="M27.573 40.3861C27.3852 40.855 26.8657 41.0962 26.3863 40.9361L8.57812 35V46.9703L29.5469 54.3284V35.4499L27.573 40.3861Z" fill="#C1C1C1" />
                            </svg>
                            <p className='textinnermiddle'>There are no products in this collection.</p>
                            <span>Search to add products.</span>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Createcollection